// Cart coupon AJAX — intercept „Zastosuj" click, fetch cart URL, replace .cart_totals
// bez pełnego page reloadu. User widzi nową cenę + rabat od razu.
//
// Fallback bez JS: przycisk submituje form natywnie (POST → reload) — tak jak dziś.
// Semantyka WC nietknięta — obsługujemy tylko UX.

function initCartCoupon() {
  const form = document.querySelector('form.woocommerce-cart-form');
  if (!form) return;
  if (form.__kbCouponBound) return;
  form.__kbCouponBound = true;

  const cartUrl = form.getAttribute('action') || location.href;
  const totalsSel = '.cart_totals';
  const noticesSel = '.woocommerce-notices-wrapper, .kb-cart-notices';

  async function ajaxApplyCoupon(couponCode, buttonEl) {
    const totals = document.querySelector(totalsSel);
    if (!totals) return null;

    // Wizualne wskazanie że coś się dzieje.
    totals.style.transition = 'opacity .18s ease';
    totals.style.opacity = '0.55';
    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.dataset.kbOriginalText = buttonEl.textContent;
      buttonEl.textContent = '…';
    }

    try {
      const fd = new FormData();
      fd.set('coupon_code', couponCode);
      fd.set('apply_coupon', 'Zastosuj');
      // WC oczekuje `woocommerce-cart-nonce` w POST — bierzemy z form (żeby przeszło nonce check).
      const nonce = form.querySelector('input[name="woocommerce-cart-nonce"]')?.value;
      if (nonce) fd.set('woocommerce-cart-nonce', nonce);
      const _wp_http_referer = form.querySelector('input[name="_wp_http_referer"]')?.value || location.pathname;
      fd.set('_wp_http_referer', _wp_http_referer);

      const res = await fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: fd,
        headers: { Accept: 'text/html' },
      });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // 1) Podmień cart_totals (nowa suma + discount row)
      const newTotals = doc.querySelector(totalsSel);
      if (newTotals) {
        // Krótki fade-out → replace → fade-in.
        totals.outerHTML = newTotals.outerHTML;
      }

      // 2) Zaktualizuj notice (success/error).
      const newNotices = doc.querySelector('.woocommerce-notices-wrapper');
      let noticesTarget = document.querySelector('.woocommerce-notices-wrapper');
      if (!noticesTarget) {
        // Wstaw wrapper na górze koszyka.
        noticesTarget = document.createElement('div');
        noticesTarget.className = 'woocommerce-notices-wrapper mb-6';
        form.parentNode.insertBefore(noticesTarget, form);
      }
      if (newNotices) {
        noticesTarget.innerHTML = newNotices.innerHTML;
      }

      // 3) Podmień też sekcję line-items (jeśli WC zmienił np. ilości / cross-sell).
      // Skip: użytkownik nie oczekuje tego, byłby confusing flicker.

      // 4) Fade in nowej sekcji + scroll do notice.
      const freshTotals = document.querySelector(totalsSel);
      if (freshTotals) {
        freshTotals.style.transition = 'opacity .35s cubic-bezier(.22,1,.36,1)';
        freshTotals.style.opacity = '0';
        requestAnimationFrame(() => { freshTotals.style.opacity = '1'; });
      }
      if (noticesTarget && noticesTarget.textContent.trim()) {
        try {
          noticesTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (_) { /* no-op */ }
      }

      // 5) Re-bind (nowy button po replace).
      form.__kbCouponBound = false;
      initCartCoupon();

      // 6) WC event — mini-cart etc. słucha `updated_cart_totals`.
      if (window.jQuery) {
        try { window.jQuery(document.body).trigger('updated_cart_totals'); } catch (_) {}
        try { window.jQuery(document.body).trigger('wc_fragments_refreshed'); } catch (_) {}
      }
    } catch (e) {
      // Cichy fallback: uruchom natywny submit.
      form.submit();
    } finally {
      const stillTotals = document.querySelector(totalsSel);
      if (stillTotals) stillTotals.style.opacity = '';
      // Button może już nie istnieć po replace — no-op safe.
    }
  }

  form.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="apply_coupon"], input[name="apply_coupon"]');
    if (!btn) return;
    const input = form.querySelector('input[name="coupon_code"]');
    const code = (input && input.value || '').trim();
    if (!code) return; // pozwól WC nasypać własny "brak kodu" error via native submit
    e.preventDefault();
    ajaxApplyCoupon(code, btn);
  });

  // Enter w polu code = klik przycisku Zastosuj (bez submit całego formularza).
  const codeInput = form.querySelector('input[name="coupon_code"]');
  if (codeInput) {
    codeInput.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter') return;
      ev.preventDefault();
      const btn = form.querySelector('button[name="apply_coupon"]');
      const code = codeInput.value.trim();
      if (!code || !btn) return;
      ajaxApplyCoupon(code, btn);
    });
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initCartCoupon();
  else document.addEventListener('DOMContentLoaded', initCartCoupon);
}

export {};
